export default "__VITE_ASSET__hPZjksrm__"